import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=49937231&scoped=true&"
import script from "./CartIcon.vue?vue&type=script&lang=js&"
export * from "./CartIcon.vue?vue&type=script&lang=js&"
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=49937231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49937231",
  null
  
)

export default component.exports